module.exports = __webpack_public_path__ + "img/Live.d6d2d22b.svg";